import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lodashValues from 'lodash/fp/values';

import {
  USER_ROLE_PARTNER,
  USER_ROLE_ADMIN,
  USER_ROLE_LANDLORD,
} from 'common/userRoles';

import {
  SCREEN_ID_PARTNER_MARKET_SUNRISE_LISTING_FLOW,
  SCREEN_ID_PARTNER_MARKET_LISTING_FLOW,
} from 'client/constants/screenIds';

import {
  getPartnerSignupType,
} from 'common/partnerHelpers';

import branch from 'client/core/branch';
import allowedRoles from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import PartnerActions from 'client/actions/Partner';
import NavigatorActions from 'client/actions/Navigator';
import MarketActions from 'client/actions/Market';
import HelpCardActions from 'client/actions/HelpCard';
import SrPartnerMarketSunriseListingForm from 'client/components/SrPartnerMarketListingForm/SrPartnerMarketSunriseListingForm';

@withTransitionHook
@withScreenId(SCREEN_ID_PARTNER_MARKET_SUNRISE_LISTING_FLOW)
@withScrollToTop
@allowedRoles({
  roles: [
    USER_ROLE_ADMIN,
    USER_ROLE_PARTNER,
    USER_ROLE_LANDLORD,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@branch(({ match }) => ({
  currentUser: ['currentUser'],
  userAgent: ['analytics', 'userAgent'],
  partner: ['partners', 'bySlug', match.params.partnerSlug],
  marketsById: ['markets', 'byId'],
}))
@branch(({ partner }) => {
  const cursors = {};
  if (partner) {
    cursors.helpCards = [
      'helpCards',
      'list',
      [SCREEN_ID_PARTNER_MARKET_LISTING_FLOW, getPartnerSignupType(partner)].join('-'),
    ];
  }

  return cursors;
})
class MarketingPartnerSunriseListingPage extends Component {
  static fetchData(match, inject) {
    const partnersBySlug = inject.state.get(['partners', 'bySlug']);
    const promises = [
      MarketActions.getList(inject),
    ];

    if (!partnersBySlug[match.params.partnerSlug]) {
      promises.push(PartnerActions.loadPartnerBySlug(inject, {
        slug: match.params.partnerSlug,
      }));
    }

    return Promise.all(promises).then(() => {
      const partner = inject.state.get(['partners', 'bySlug', match.params.partnerSlug]);
      return Promise.all([
        HelpCardActions.getList(inject, {
          screenId: SCREEN_ID_PARTNER_MARKET_LISTING_FLOW,
          partnerSignupType: getPartnerSignupType(partner),
        }),
      ]);
    });
  }

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    partner: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    helpCards: PropTypes.array,
  }

  _onPartnerMarketListingFormBack = () => {
    const { partner, dispatch } = this.props;
    dispatch(NavigatorActions.replace, { to: `/partner/${partner.slug}` });
  }

  render() {
    const {
      currentUser,
      userAgent,
      partner,
      helpCards,
      dispatch,
      marketsById,
      history,
    } = this.props;

    if (
      !partner
    ) {
      return <div className='loading-gif' />;
    }

    return (
      <SrPartnerMarketSunriseListingForm
        currentUser={currentUser}
        userAgent={userAgent}
        partnerId={partner.id}
        onBack={this._onPartnerMarketListingFormBack}
        history={history}
        dispatch={dispatch}
        partner={partner}
        helpCards={helpCards}
        marketsList={lodashValues(marketsById)}
      />
    );
  }
}

MarketingPartnerSunriseListingPage.displayName = 'MarketingPartnerSunriseListingPage';

export default MarketingPartnerSunriseListingPage;
